import React from 'react';
import { TreeSelect, TreeSelectProps } from 'antd';
import { FilterCommonProps } from '@/component/FilterCommon/Filter';
import { axiosHttp } from '@/utils/http';
import { isError } from '@/component/common/error';
import { useSearchConditionPc } from '../hooks/useSearchCondition';
import styled from 'styled-components';
import { FilterTreeSelectPc } from '../FilterTreeSelect/FilterTreeSelectPc';

const TreeSelectView = styled(FilterTreeSelectPc)`

`



export interface FilterClientAreaPcProps extends TreeSelectProps {
}

export const FilterClientAreaPc = (props: FilterClientAreaPcProps) => {
  const { searchCondition, loading, getInitData } = useSearchConditionPc({ client: ['new_area'] });
  const { value, placeholder = '客户地区', ...reset } = props;


  return (
    <TreeSelectView
      style={{ width: '100%' }}
      multiple
      showSearch
      allowClear
      value={value}
      loading={loading}
      getInitData={getInitData}
      dropdownStyle={{ maxHeight: 400, overflow: "auto", minWidth: 400,whiteSpace: 'nowrap',textOverflow: 'ellipsis' }}
      treeCheckable
      // treeData={this.handleTreeData(client ? client.new_area : [])}
      treeData={searchCondition.client?.new_area || []}
      placeholder={placeholder}
      getPopupContainer={(triggerNode) => triggerNode.parentNode}
      treeDefaultExpandAll
      treeNodeFilterProp={'title'}
      {...reset}
      // dropdownClassName="filter-select"
      // onChange={(values, labels, extra) => {

      //   console.log(values, labels);
      //   // this.onChangeValue(dataIndex, arg[0], { filterProps: props });
      //   props.onChange && props.onChange(values, labels, extra);
      // }}
    />
  );
};
